export default __webpack_public_path__ + "static/tech-1-45373ae107bfdfb2ae9e2596e94bd4e5.jpg";